import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ToastPlugin from './utils/toast'
import { installI18n } from './i18n'
import './assets/css/theme.css'

Vue.use(ToastPlugin)
installI18n()
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
